<template>
  <section class="page-wrap">
    <!-- 顶部操作 start -->
    <section class="form jn-form-style">
      <div class="form-item btn-wrap">
        <el-button
          type="primary"
          style="margin-left: 5px"
          icon="el-icon-refresh"
          class="refresh"
          @click="onHandleRefresh"
        ></el-button>

        <el-button @click="onHandleCreate" type="primary" icon="el-icon-search"
          >新增</el-button
        >
      </div>

      <div class="form-item">
        <el-select
          v-model="formData.logistic_business_id"
          filterable
          clearable
          placeholder="集配中心"
        >
          <el-option
            v-for="item of logisticList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>

      <div class="form-item">
        <!-- <el-input
          v-model="formData.supplier_name"
          clearable
          placeholder="供应商名称"
        >
        </el-input> -->
            <el-select
            filterable
            v-model="formData.supplier_id"
            clearable
            placeholder="选择供应商"
          >
            <el-option
              v-for="item in supplierList"
              :key="item.id"
              :label="`${item.title}-${item.id}`"
              :value="item.id"
            >
            </el-option>
          </el-select>
      </div>

      <div class="form-item">
        <el-input v-model="formData.as_no" clearable placeholder="售后单号">
        </el-input>
      </div>

      <div class="form-item">
        <el-select
          placeholder="扣款类型"
          v-model="formData.deduction_type"
          clearable
        >
          <el-option
            v-for="item in deductionTypeList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>

      <div class="form-item">
        <el-select
          placeholder="扣款状态"
          v-model="formData.deduction_state"
          clearable
        >
          <el-option
            v-for="item in deductionStateList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>

      <div class="form-item">
        <el-select
          placeholder="审核状态"
          v-model="formData.check_state"
          clearable
        >
          <el-option
            v-for="item in checkStateList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>

      <div class="form-item">
        <el-date-picker
          type="daterange"
          range-separator="至"
          start-placeholder="添加日期起"
          end-placeholder="添加日期止"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          align="right"
          v-model="dataTime"
          @change="changeDate"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </div>

      <div class="form-item">
        <el-date-picker
          type="daterange"
          range-separator="至"
          start-placeholder="扣款时间起"
          end-placeholder="扣款时间止"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          align="right"
          v-model="deductionTime"
          @change="changeDeductionTime"
        >
        </el-date-picker>
      </div>

      <div class="form-item">
        <el-input
          v-model="formData.trade_no"
          clearable
          placeholder="退款流水号"
        >
        </el-input>
      </div>
      <div class="form-item">
        <el-input
          v-model="formData.operate_name"
          clearable
          placeholder="添加人"
        >
        </el-input>
      </div>
      <div class="form-item btn-wrap">
        <el-button
          type="warning"
          icon="el-icon-s-operation"
          :disabled="!selectIds.length || selectCategory !== 'pending'"
          @click="onBatchAudit"
          >审核</el-button
        >
      </div>
      <div class="form-item btn-wrap">
        <el-button @click="onHandleSearch" type="primary" icon="el-icon-search"
          >查询</el-button
        >
        <el-button
          :disabled="!tableData.length || disabledExport"
          @click="onHandleExport"
          type="warning"
          icon="el-icon-download"
          >导出</el-button
        >
      </div>
    </section>
    <!-- 顶部操作 end -->

    <section class="content">
      <!-- 列表 start -->
      <table-list
        ref="refTableList"
        v-loading="loadingData"
        :tableData="tableData"
        :isAudit="isAudit"
        @on-edit="onHandleEdit"
        @on-change="onHandleSearch('resetPage')"
        @selection-change="onSelectionChange"
      ></table-list>
    </section>
    <!-- 列表 end -->

    <!-- 分页 start -->
    <div class="pagination">
      <el-pagination
        type="primary"
        :current-page="formData.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="formData.pageSize"
        :total="total"
        @size-change="onHandleSizeChange"
        @current-change="onHandleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        background
      >
      </el-pagination>
    </div>
    <!-- 分页 end -->

    <!-- 编辑，弹窗 start -->
    <edit-dialog
      ref="refEditDialog"
      @on-change="onHandleSearch('resetPage')"
      :deductionTypeList="deductionTypeAddList"
    ></edit-dialog>
    <!-- 编辑，弹窗 end -->
  </section>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
// import { formatDate } from "@/utils/tools/date.js";
import TableList from "./modules/table-list/index.vue";
import { getSupplierDeductionList } from "@/api/general/operation-center/index";
import { postSupplierDeductionExport } from "@/api/export/center";
import EditDialog from "./modules/edit-dialog/index.vue";
import {
  DEDUCTION_TYPE_ENUM,
  CHECK_STATUS,
  DEDUCTION_STATUS,
} from "./utils/enum/index";
import { getSupplierDeductionTypeList } from "@/api/general/operation-center/index";
// import mock from "./mock.js";
import { getSupplierSelectList } from "@/api/general/operation-center/index.js";
import { postSupplierDeductionBatchExamine } from "@/api/general/operation-center/index";
export default {
  name: "SupplierDeductionManage",
  components: {
    TableList,
    EditDialog,
  },
  data() {
    return {
      loadingData: false,
      disabledExport: false,
      loadingCoupon: false,
      isAudit: false, // 是否有审核权限
      dataTime: [], // 时间对象
      deductionTime: [], // 扣款时间对象
      logisticList: [], // 集配中心列表
      deductionTypeList: [], // 扣款类型下拉
      deductionTypeAddList: [], // 扣款类型新增
      deductionStateList: Object.values(DEDUCTION_STATUS), // 扣款状态下拉
      checkStateList: Object.values(CHECK_STATUS), // 审核状态下拉
      formData: {
        logistic_business_id: "", // 集配中心id
        supplier_name: "", // 供应商名称
        as_no: "", // 售后单号
        trade_no: "", //退款流水号
        deduction_type: "", // 扣款类型
        deduction_state: "", // 扣款状态
        check_state: "", // 审核状态
        start_date: "", // 添加日期起
        end_date: "", // 添加日期止
        deduction_start_time: "", //扣款开始时间
        deduction_end_time: "", //扣款结束时间
        supplier_id:'',
        operate_name:'',
        page: 1,
        pageSize: 10,
      },
      formDataClone: {}, // 复制一份，用于初始化
      tableData: [],
       supplierList: [],
      total: 0,
      selectIds: [], // 批量勾选的流水 id 列表
      selectCategory: "", // 当前勾选批次状态：pending（待审核）/ unDeduct（待扣款）
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      }, // 时间范围
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.onInitData();
    this.getAjaxSupplierSelectList();
  },
  methods: {
       /**
     * 获得供应商下拉列表
     */
    async getAjaxSupplierSelectList() {
      try {
        const { data } = await getSupplierSelectList({
          is_all: 0, //  0或不传为权限下数据
          is_state: 2, // 2 启用禁用都返回
        });
        this.supplierList = data;
      } catch (err) {
        console.log("ajax getSupplierSelectList err", err);
      }
    },
    /**
     * 获取扣款类型下拉列
     */
    async ajaxGetDeductionTypeList() {
      try {
        const { data } = await getSupplierDeductionTypeList();
        this.deductionTypeList = data.select;
        this.deductionTypeAddList = data.add;
        console.log("ajax getSupplierDeductionTypeList", data);
      } catch (err) {
        console.log("ajax getSupplierDeductionTypeList err", err);
      }
    },
    /**
     * 初始化数据
     */
    onInitData() {
      this.formDataClone = cloneDeep(this.formData);
      this.ajaxGetTableData();
      this.ajaxGetDeductionTypeList();
      this.ajaxGetLogisticList();
    },
    /**
     * 获取集配中心列表
     */
    async ajaxGetLogisticList() {
      try {
        const { data } = await this.$api.general.businessList();
        this.logisticList = data;
      } catch (err) {
        console.log("ajax ajaxGetLogisticList err", err);
      }
    },
    /**
     * 查询列表数据
     */
    async ajaxGetTableData() {
      this.loadingData = true;
      const params = { ...this.formData };
      try {
        const { data } = await getSupplierDeductionList(params);
        const { total, data: list, is_audit } = data;
        this.total = total;
        this.tableData = list;
        this.isAudit = is_audit;
      } catch (err) {
        console.log("ajax getSupplierDeductionList err", err);
      } finally {
        this.loadingData = false;
        // 模拟数据
        // this.tableData = mock.tableData;
        // this.total = mock.total;
      }
    },
    /**
     * 日期发生了变化
     */
    changeDate(data) {
      this.formData.start_date = data?.[0] || "";
      this.formData.end_date = data?.[1] || "";
    },
    /**
     * 扣款日期发生了变化
     */
    changeDeductionTime(data) {
      this.formData.deduction_start_time = data?.[0] || "";
      this.formData.deduction_end_time = data?.[1] || "";
    },
    /**
     * 查询表单
     */
    onHandleSearch(type) {
      // 重置为第一页
      if (type === "resetPage") {
        this.formData.page = 1;
      }
      this.ajaxGetTableData();
    },
    /**
     * 重置数据
     */
    onHandleRefresh() {
      this.formData = {
        ...this.formDataClone,
      };
      this.dataTime = [];
      this.deductionTime = [];
      this.deliveryList = [];
      this.ajaxGetTableData();
    },
    /**
     * 新增
     */
    onHandleCreate() {
      this.$refs.refEditDialog.onInitData();
    },
    /**
     * 导出数据
     */
    async onHandleExport() {
      this.disabledExport = true;
      const { username } = JSON.parse(sessionStorage.getItem("userInfo"));
      try {
        const params = {
          ...this.formData,
          user_name: username,
          token: sessionStorage.getItem("token"),
        };
        delete params.page;
        delete params.pageSize;
        await postSupplierDeductionExport(params);
        this.goExportCenter();
      } catch (err) {
        console.log("ajax postSupplierDeductionExport err", err);
      } finally {
        this.disabledExport = false;
      }
    },
    /**
     * 导出后引导弹框
     */
    goExportCenter() {
      // 新窗口打开下载中心
      const routerInfo = this.$router.resolve({
        path: "/export-center",
      });
      window.open(routerInfo.href, "_blank");
      this.disabledExport = false;
    },
    /**
     * 编辑
     */
    onHandleEdit(data) {
      this.$refs.refEditDialog.onInitData(data);
    },
    /**
     * 列表勾选变化
     */
    onSelectionChange({ ids, category }) {
      this.selectIds = ids;
      this.selectCategory = category;
    },
    /**
     * 批量审核（仅待审核数据可批量审核）
     */
    onBatchAudit() {
      if (!this.selectIds.length) {
        this.$message.warning("请先勾选数据");
        return;
      }
      // 点击时再次校验：只能批量审核「待审核」数据（check_state=0）
      const rows = this.tableData.filter((row) => this.selectIds.includes(row.id));
      const notPending = rows.filter((row) => Number(row.check_state) !== 0);
      if (notPending.length) {
        this.$message.warning("只能批量审核「待审核」状态的数据，请重新勾选");
        return;
      }
      this.$confirm(
        `确定批量审核选中的 ${this.selectIds.length} 条数据？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        }
      )
        .then(async () => {
          try {
            await postSupplierDeductionBatchExamine({ ids: this.selectIds });
            this.$message.success("操作成功！");
            this.$refs.refTableList.clearSelect();
            this.onHandleSearch("resetPage");
          } catch (error) {
            console.log("ajax postSupplierDeductionBatchExamine err", error);
          }
        })
        .catch(() => {});
    },
    /**
     * 修改了每页数据条数
     */
    onHandleSizeChange(val) {
      this.formData.page = 1;
      this.formData.pageSize = val;
      this.ajaxGetTableData();
    },
    /**
     * 修改了页码
     */
    onHandleCurrentChange(val) {
      this.formData.page = val;
      this.ajaxGetTableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.page-wrap {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  padding: 10px;
  .form {
    padding: 13px 15px;
  }
  .content {
    flex: 1;
    overflow-y: hidden;
  }
  .pagination {
    .el-pagination {
      padding: 10px 20px;
      box-sizing: border-box;
    }
  }
}
/** 下拉选择模态框样式 */
.select-popper-wrap {
  .el-select-dropdown {
    &__item {
      .content {
        max-width: 200px;
        @include ellipsis-lines;
      }
    }
  }
}
/** 操作按钮样式 */
.deduct,
.coupon {
  color: #fff;
  border: none;
}
.deduct {
  background-color: #c42c2c;
  &.disabled {
    background-color: rgba(#c42c2c, 0.3);
  }
}
.coupon {
  background-color: #409eff;
  &.disabled {
    background-color: rgba(#409eff, 0.3);
  }
}
</style>
